import { BaseContainerModel } from '../base-container.model';
import { app_mst_link_grp_to_role_RowClass } from '../../dbschema';

export class TenantTeamRoleContainerModel extends BaseContainerModel {
    app_mst_link_grp_to_role: app_mst_link_grp_to_role_RowClass = new app_mst_link_grp_to_role_RowClass();
}